import React from 'react';
import humanizeValue from '@utils/humanizeUtil';
import { getMetricUnitByKey } from '@utils/metrics';
import { getPrimaryKeyFromPercentageLocalKey } from '@src/utils/metrics/metricHelpers';
import { StyledCell } from './styled';

function ValueCell({ cellData, column }) {
  if (['NA', 'low'].includes(cellData)) {
    return (
      <StyledCell>
        <span>{cellData}</span>
      </StyledCell>
    );
  }
  const { metric } = column;
  // LOCAL_METRIC_SWITCH_MAP contains all the local calculated metrics and its unit is %
  // TODO check this
  const unit =
    column.mfPctChecked || !!getPrimaryKeyFromPercentageLocalKey({ metricKey: metric })
      ? '%'
      : getMetricUnitByKey({ metricKey: metric });
  const { humanizedNumber, humanizedUnit } = humanizeValue(cellData, metric, unit as string);

  return (
    <StyledCell>
      <div style={{ flex: 1 }}>{`${humanizedNumber} ${humanizedUnit}`}</div>
    </StyledCell>
  );
}

export default React.memo(ValueCell);
